var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M15.286 15.29c.63.63.18 1.71-.71 1.71H1.406c-.89 0-1.33-1.08-.7-1.71L1.996 14V9c0-3.08 1.63-5.64 4.5-6.32V2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.68c2.86.68 4.5 3.25 4.5 6.32v5zM5.996 18h4a2 2 0 1 1-4 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBlackIcon);
export default __webpack_public_path__ + "static/media/notification-black-icon.1b43e28ab6d25376ebea2a299010e353.svg";
export { ForwardRef as ReactComponent };